module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic15.c315976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic15.png
// module id = 533
// module chunks = 1